import { bool, boolean, number, object, string, array, mixed, ref } from 'yup'
import { isValidUrl, validateAddressComponent, validateAddressComponentsArray } from 'src/utils/yupCustomMethods'
import { validateOptionalDate } from 'src/utils/formDataManipulation'
import { validEmailPattern } from 'src/constants/general';

const phoneRegExp = /^\(\d{3}\)-\d{3}-\d{4}$/;

// Onboarding
// /new
export const OnboardingSchema = object ({
    emailAddress: string().email().required(),
    confirmEmail: string().oneOf([ref('emailAddress')]).required()
});

// Firm New App
// firm/main
export const FirmInfoSchema = object ({
    // firmName: string().typeError('step1').required('step1'),
    //   practiceType: string().typeError('step2').required('step2'),
    //   establishmentDate: string().trim('step3').length(10, 'step3').validDate('step3').typeError('step3').required('step3'),
    //   contactInfo: object({      
    //     phoneNumber: string().typeError('step4').matches(phoneRegExp,'step4').min(14, 'step4').required('step4'),
    //     website: string().optional().nullable().test('step10','step10',val => isValidUrl(val)),
    //     faxNumber: string().optional().nullable(),
    //   }),
    //   mailAddress: object({
    //     addressComponents: array().of(object({
    //       shortName: string().test('component-test', 'step5', validateAddressComponent),
    //       types: array().of(string()).required('step5')
    //     })).test('component-array', 'step5', validateAddressComponentsArray).required('step5')
    //   }),
    //   isBillingEqualToMail: boolean().typeError('step6').required('step6'),
    //   billingAddress: object().when('isBillingEqualToMail', {
    //     is: false,
    //     then: object({
    //       addressComponents: array().of(object({
    //         shortName: string().test('component-test', 'step6', validateAddressComponent),
    //         types: array().of(string()).required('step6')
    //       })).test('component-array', 'step6', validateAddressComponentsArray).required('step6')
    //     }),
    //     otherwise: sch => sch.optional().nullable()
    //   }),
    //   isSecondaryContactAdded: boolean().typeError('step7').required('step7'),
    //   secondaryContact: object().when('isSecondaryContactAdded', {      
    //     is: true,
    //     then: object({
    //       firstName: string().typeError('step7').required('step7'),
    //       lastName: string().typeError('step7').required('step7'),
    //       phoneNumber: string().typeError('step7').required('step7'),
    //       emailAddress: string().typeError('step7').required('step7').email('step7'),
    //     }),
    //     otherwise: sch => sch.optional().nullable()
    //   }),
    //   numberOfOffices: string().typeError('step9').required('step9')
});

// firm/real-estate
export const FirmRealEstateSchema = object ({
    // hasFirmMemberWithEscrowLicense: bool().typeError('step1').required('step1'),
    // hasAgreementWithTitleCompanies: bool().typeError('step2').required('step2'),
    // agreementWithTitleCompaniesFile: array().when('hasAgreementWithTitleCompanies', {
    //   is: true,
    //   then: sch => sch.min(1, 'step2').typeError('step2').required('step2'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasFirmMemberFeeAttorney: bool().typeError('step3').required('step3'),
    // hasFirmMemberOutsideClosingAttorney: bool().typeError('step4').required('step4'),
    // nonAttorneysWithEscrowLicenseQuantity: number().typeError('step5').required('step5'),
});

// firm/relationships
export const FirmRelationshipsSchema = object ({
    //hasSuedClientForFees: bool().required('step1'),
});

// firm/equity-interest
export const FirmEquityInterestSchema = object ({
    // providesWrittenDisclosure: boolean().typeError('step1').required('step1'),
    // acceptedEquityOfAttorneysFees: boolean().typeError('step2').required('step2'),
    // acceptedEquityOfAttorneysFeesDescription: string().when('acceptedEquityOfAttorneysFees', {
    //   is: true,
    //   then: sch => sch.required('step2'),
    //   otherwise: sch => sch.nullable().notRequired()
    // }),
    // providedProfessionalLegalServices: boolean().typeError('step3').required('step3'),
    // providedProfessionalLegalServicesDescription: string().when('providedProfessionalLegalServices', {
    //   is: true,
    //   then: sch => sch.required('step3'),
    //   otherwise: sch => sch.nullable().notRequired()
    // })
});

// firm/loss-prevention
export const FirmLossPreventionSchema = object ({
    // shareOfficeSpaceOrExpenses: bool().required('step1'),
    // sharedSpaceExpensesAttorneys: array().when('shareOfficeSpaceOrExpenses', {
    //   is: true,
    //   then: sch => sch.min(1, 'step1').of(
    //     object({
    //     fullName: string().required('step1'),
    //     dateSharingBegan: string().trim().length(10, 'step1').validDate('step1').typeError('step1').required('step1')
    //     })
    // ),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    workScheduling: array(string()).min(1, 'step3').required('step3'),
    workSchedulingOther: string().when('workScheduling', {
      is: (value: string[] | undefined) => value?.includes('Other') === true,
      then: sch => sch.required('step3'),
      otherwise: sch => sch.optional().nullable()
    }),
    // engagementLetters: bool().required('step4'),
    // nonEngagementLettersWhenDeclining: bool().required('step5'),
    // disengagementLettersWhenCeasing: bool().required('step6'),
    avoidConflictOfInterests: array(string()).min(1, 'step7').required('step7'),
    avoidConflictOfInterestsOther: string().when('avoidConflictOfInterests', {
      is: (value: string[] | undefined) => value?.includes('Other') === true,
      then: sch => sch.required('step7'),
      otherwise: sch => sch.optional().nullable()
    }),
    // conflictWaiversPotentialConflict: bool().required('step8'),
    // conflictWaiversRepresentationAffected: bool().required('step8'),
    // conflictWaiversAnotherAttorneyConsult: bool().required('step8'),
    // timesSuedClientsForFees: number().required('step9'),
    // howManyClientsSuedFiledCounterClaim: number().required('step10'),
});

// attorneys/main
export const AttorneyMainSchema = object ({
    // firstName: string().required('mainSection'),
    // lastName: string().required('mainSection'),
    // isResumeAvailable: bool().required('mainSection'),
    // resumeFile: array().when('isResumeAvailable', {
    //   is: true,
    //   then: sch => sch.min(1, 'mainSection').of(object({
    //     id: number().required('mainSection'),
    //     fileName: string().required('mainSection'),
    //     fileUrl: string().required('mainSection')
    //   })).required('mainSection'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // barCardNumber: string().required('aboutSection'),
    // position: string().required('aboutSection'),
    // emailAddress: string().matches(validEmailPattern).required('aboutSection'),
    // yearsInPrivatePractice: string().required('aboutSection'),
    // license: object({
    //   licenseDate: string().trim().nullable()
    // .when('isLicensedInOtherState', {
    //   is: false,
    //   then: string().trim().length(10).required('licensingSection'),
    //   otherwise: string().trim().optional().nullable().test('licensingSection','licensingSection',val=> validateOptionalDate(val))
    // }),
    // dateLicensedInOtherState: string().trim().nullable()
    // .when('isLicensedInOtherState', {
    //   is: true,
    //   then: string().trim().length(10).required('licensingSection'),
    //   otherwise: string().trim().optional().nullable().test('licensingSection','licensingSection',val=> validateOptionalDate(val))
    // }),
    // otherState : string().trim().optional()
    // .when('isLicensedInOtherState', {
    //   is: true,
    //   then: string().trim().length(2).required('licensingSection'),
    //   otherwise: string().trim().optional().nullable()
    // }),
    // isLicensedInOtherState: bool().required('licensingSection'),
    // licensesInfo : string().optional().nullable(),
    // percentageOfWorkSpent: string().when('isLicensedInOtherState',{
    //   is : true,
    //   then: string().required('licensingSection'),
    //   otherwise : string().optional().nullable()
    // })
    // }).required('licensingSection'),
    
    // // workHistory: object({
    // //   joinedDate: string().trim().length(10, 'historySection').validDate('historySection').required('historySection'),
    // //   hoursPerWeek: number().moreThan(0,'historySection').required('historySection')
    // // }).required('historySection')
    // workHistory: object().when('isResumeAvailable', {
    //   is: false,
    //   then: object({
    //     noEmploymentHistory : mixed().optional().oneOf([true,false,null]), //bool().required('historySection1'),
    //     joinedDate: string().trim().length(10, 'historySection').validDate('historySection').required('historySection'),
    //     hoursPerWeek: number().moreThan(0,'historySection').required('historySection'),
    //     formerEmployers : array().when('noEmploymentHistory',{
    //       is: false,
    //       then : schema => schema.of(
    //         object().shape({
    //           firmName: string().required('historySection'),
    //           position: string().required('historySection'),
    //           employmentDateFrom: string().trim().length(7, 'historySection').required('historySection'),
    //           employmentDateTo: string().trim().length(7, 'historySection').required('historySection'),
    //         })
    //       ),
    //       otherwise : schema => schema.notRequired() 
    //     }
    //     ),
    //   }),
    //   otherwise : object({
    //     noEmploymentHistory :  mixed().optional().oneOf([true,false,null]),
    //     joinedDate: string().trim().length(10, 'historySection').validDate('historySection').required('historySection'),
    //     hoursPerWeek: number().moreThan(0,'historySection').required('historySection'),
    //     formerEmployers : array().notRequired().nullable(),
    //   })
    // }).required('historySection')
});

export const NewFormAttorneyMainSchema = object ({
    // firstName: string().required('mainSection'),
    // lastName: string().required('mainSection'),
    // isResumeAvailable: bool().required('mainSection'),
    // resumeFile: object().when('isResumeAvailable', {
    //   is: true,
    //   then: sch => sch.shape({
    //     id: number().required('mainSection'),
    //     fileName: string().required('mainSection'),
    //     fileUrl: string().required('mainSection')
    //   }).required('mainSection'),
    //   otherwise: sch => sch.optional().nullable()
    // })
});

export const NewFormAttorneyAboutSchema = object({
    // barCardNumber: string().required('aboutSection'),
    // position: string().required('aboutSection'),
    // emailAddress: string().email().required('aboutSection'),
    // yearsInPrivatePractice: string().required('aboutSection'),
});

export const NewFormAttorneyLicenseSchema = object({
    // licenseDate: string().trim().nullable()
    // .when('isLicensedInOtherState', {
    //   is: false,
    //   then: string().trim().length(10).required('licensingSection'),
    //   otherwise: string().trim().optional().nullable().test('licensingSection','licensingSection',val=> validateOptionalDate(val))
    // }),
    // dateLicensedInOtherState: string().trim().nullable()
    // .when('isLicensedInOtherState', {
    //   is: true,
    //   then: string().trim().length(10).required('licensingSection'),
    //   otherwise: string().trim().optional().nullable().test('licensingSection','licensingSection',val=> validateOptionalDate(val))
    // }),
    // otherState : string().trim().optional()
    // .when('isLicensedInOtherState', {
    //   is: true,
    //   then: string().trim().length(2).required('licensingSection'),
    //   otherwise: string().trim().optional().nullable()
    // }),
    // isLicensedInOtherState: bool().required('licensingSection'),
    // licensesInfo : string().optional().nullable(),
    // percentageOfWorkSpent: string().when('isLicensedInOtherState',{
    //   is : true,
    //   then: string().required('licensingSection'),
    //   otherwise : string().optional().nullable()
    // })
});

export const NewFormAttorneyWorkHistorySchema = object ({
    // isResumeAvailable: bool().required('isResumeAvailable'),
    // workHistory: object().when('isResumeAvailable', {
    //   is: false,
    //   then: object({
    //     noEmploymentHistory : bool().required('historySection'),
    //     joinedDate: string().trim().length(10, 'historySection').validDate('historySection').required('historySection'),
    //     hoursPerWeek: number().moreThan(0,'historySection').required('historySection'),
    //     formerEmployers : array().when('noEmploymentHistory',{
    //       is: false,
    //       then : schema => schema.of(
    //         object().shape({
    //           firmName: string().required('historySection'),
    //           position: string().required('historySection'),
    //           employmentDateFrom: string().trim().length(7, 'historySection').required('historySection'),
    //           employmentDateTo: string().trim().length(7, 'historySection').required('historySection'),

    //         })
    //       ),
    //       otherwise : schema => schema.notRequired()
    //     }
    //     ),
    //   }),
    //   otherwise : object({
    //     noEmploymentHistory : bool().isTrue().required('historySection'),
    //     joinedDate: string().trim().length(10, 'historySection').validDate('historySection').required('historySection'),
    //     hoursPerWeek: number().moreThan(0,'historySection').required('historySection'),
    //     formerEmployers : array().notRequired().nullable(),
    //   })

    // })
})

// attorneys/relationships
export const AttorneyRelationshipsSchema = object ({
    // hasICOCAttorneys: boolean().typeError('step2').required('step2'),
    // icocAttorneys: number().when('hasICOCAttorneys', {
    //   is: true,
    //   then: sch => sch.moreThan(0, 'NO_ICOC'),
    //   otherwise: sch => sch.equals([0], 'HAS_ICOC')
    // }),
    // hasICOCInAnotherFirm: boolean().typeError('step3').required('step3'),
    // hasICOCInAnotherFirmDescription: string().when('hasICOCInAnotherFirm', {
    //   is: true,
    //   then: sch => sch.typeError('step3').required('step3'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // isSolePractitioner: boolean().typeError('step4').required('step4'),
    // solePractitionerLastYear: string().when('isSolePractitioner', {
    //   is: true,
    //   then: sch => sch.typeError('step4').required('step4'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
});

// firm/securities-law
export const FirmSecuritiesLawSchema = object({
    // conductsDueDiligenceInvestigation: boolean().typeError('step1').required('step1'),
    // involvedInActionByRegulator: boolean().typeError('step2').required('step2'),
    // involvedInActionByRegulatorDescription: string().when('involvedInActionByRegulator', {
    //   is: true,
    //   then: sch => sch.required('step2'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasPreparedPortionOfProspectus: boolean().typeError('step3').required('step3'),
    // involvedInDirectSale: boolean().typeError('step4').required('step4'),
    // hasAcceptedEquityInterest: boolean().typeError('step5').required('step5'),
    // acceptEquityInterestCircumstances: string().when('hasAcceptedEquityInterest', {
    //   is: true,
    //   then: sch => sch.required('step5'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // acceptEquityInterestApprovalProcess: string().when('hasAcceptedEquityInterest', {
    //   is: true,
    //   then: sch => sch.required('step5'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasProvidedLegalServicesForOfficers: boolean().typeError('step6').required('step6'),
    // hasProvidedLegalServicesOwnedInterests: boolean().typeError('step7').required('step7')
});

// attorneys/ic-oc
export const AttorneysICOCSchema = object({
    // firstName: string().typeError('attorneyName').required('attorneyName'),
    // lastName: string().typeError('attorneyName').required('attorneyName'),
    yearStartedAsICOC: number().integer('yearStartedAsICOC').typeError('yearStartedAsICOC').moreThan(1900, 'yearStartedAsICOC').required('yearStartedAsICOC'),
    hoursOnBill: number().integer('hoursOnBill').typeError('hoursOnBill').required('hoursOnBill'),
    //   .when('hoursBilledInFirstYear', {
    //   is: (value: number | string) => !value === true,
    //   then: sch => sch.moreThan(0, 'hoursOnBill').typeError('hoursOnBill').required('hoursOnBill'),
    //   otherwise: sch => sch.typeError('typeerror').optional().nullable()
    // }),
    hoursBilledInFirstYear: number().integer('hoursBilledInFirstYear').typeError('hoursBilledInFirstYear').required('hoursBilledInFirstYear'),
    //   .when('hoursOnBill', {
    //   is: (value: number | string) => !value === true,
    //   then: sch => sch.moreThan(0, 'hoursBilledInFirstYear').typeError('hoursBilledInFirstYear').required('hoursBilledInFirstYear'),
    //   otherwise: sch => sch.typeError('typeerror').optional().nullable()
    // }),
})//, [['hoursOnBill', 'hoursBilledInFirstYear']]);

// insurance/last-insurace

// insurance/past-liability
export const AttorneyPastLiabilitySchema = object({
    // hasCanceledLiabilities: bool().required('step1'),
    // canceledLiabilitiesFile: array().when('hasCanceledLiabilities', {
    //   is: true,
    //   then: sch => sch.min(1, 'step1').of(object({
    //     id: string().required('step1'),
    //     fileName: string().required('step1')
    //   })).typeError('step1').required('step1'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasMalpracticeClaim: bool().required('step2'),
    // hasMalpracticeBasis: bool().required('step3'),
    // hasGrievanceComplain: bool().required('step4'),
    // grievanceComplainFile: array().when('hasGrievanceComplain', {
    //   is: true,
    //   then: sch => sch.min(1, 'step4').of(object({
    //     id: string().required('step4'),
    //     fileName: string().required('step4')
    //   })).typeError('step4').required('step4'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasDisciplinedAction: bool().required('step5'),
    // disciplinedActionDetails: string().when('hasDisciplinedAction', {
    //   is: true,
    //   then: sch => sch.required('step5'),
    //   otherwise: sch => sch.optional().nullable()
    // })
});

// quote/select
export const AttorneyQuoteSelectSchema = object ({
    // liabilityLimits: string().required('liabilityLimits'),
    // deductible: string().required('deductible')
});

export const AttorneyQuoteBoxSchema = object ({
    // liabilityLimits: string().required('liabilityLimits'),
    // deductible: string().required('deductible')
})

export const LicensingNewItemFormSchema = object ({
    // licenseDate: string().trim().nullable()
    // .when('isLicensedInOtherState', {
    //   is: false,
    //   then: string().trim().length(10).required('licensingSection'),
    //   otherwise: string().trim().optional().nullable().test('licensingSection','licensingSection',val=> validateOptionalDate(val))
    // }),
    // dateLicensedInOtherState: string().trim().nullable()
    // .when('isLicensedInOtherState', {
    //   is: true,
    //   then: string().trim().length(10).required('licensingSection'),
    //   otherwise: string().trim().optional().nullable().test('licensingSection','licensingSection',val=> validateOptionalDate(val))
    // }),
    // otherState : string().trim().optional()
    // .when('isLicensedInOtherState', {
    //   is: true,
    //   then: string().trim().length(2).required('licensingSection'),
    //   otherwise: string().trim().optional().nullable()
    // }),
    // isLicensedInOtherState: bool().required('licensingSection'),
    // licensesInfo : string().optional().nullable(),
    // percentageOfWorkSpent: string().when('isLicensedInOtherState',{
    //   is : true,
    //   then: string().required('licensingSection'),
    //   otherwise : string().optional().nullable()
    // })
})





// Judge New App
// judge/basic/main
export const JudgeInfoSchema = object ({
    // firstName: string().typeError('step1').required('step1'),
    // lastName: string().typeError('step1').required('step1'),
    // contactInfo: object({      
    //   firstName: string().typeError('step2').required('step2'),
    //   lastName: string().typeError('step2').required('step2'),
    //   phoneNumber: string().typeError('step2').min(14, 'step2').required('step2'),
    //   emailAddress: string().typeError('step2').email('step2').required('step2'),
    //   faxNumber: string().optional().nullable(),
    // }),
    // principalOfficeAddress: object({
    //   addressComponents: array().of(object({
    //     shortName: string().test('component-test', 'step3', validateAddressComponent),
    //     types: array().of(string()).required('step3')
    //   })).test('component-array', 'step3', validateAddressComponentsArray).required('step3')
    // }),    
    // presidingCounty: string().typeError('step4').required('step4'),
    // residingCourt: string().typeError('step5').required('step5'),
    // yearsPresidingCourt: number().typeError('step6').required('step6'),
    // yearsOverallExperience: number().typeError('step7').required('step7'),
    // barCardNumber: string().typeError('step8').required('step8'),
    // dateAdmittedTexasBar: string().trim().length(10, 'step9').validDate('step9').typeError('step9').required('step9'),
});

// judge/insurance/last-insurances
export const JudgeLastInsuranceSchema = object ({
    // insuranceCompany: string().required(),
    // liabilityLimits: string().required(),
});

// judge/insurance/past-liability
export const JudgeLiabilitySchema = object ({
    // hasInsuranceDeclined: boolean().typeError('step1').required('step1'),
    // insuranceDeclinedDetails: string().when('hasInsuranceDeclined', {
    //   is: true,
    //   then: sch => sch.typeError('step1').required('step1'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasClaimsAsserted: boolean().typeError('step2').required('step2'),
    // hasBeenRefused: boolean().typeError('step3').required('step3'),
    // refusedDetails: string().when('hasBeenRefused', {
    //   is: true,
    //   then: sch => sch.typeError('step3').required('step3'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasBeenSuspended: boolean().typeError('step4').required('step4'),
    // suspendedDetails: string().when('hasBeenSuspended', {
    //   is: true,
    //   then: sch => sch.typeError('step4').required('step4'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasActsToBaseClaim: boolean().typeError('step5').required('step5'),
});